// extracted by mini-css-extract-plugin
export default {"railOuterStyle":"SliderRail_railOuterStyle--Pzx","railInnerStyle":"SliderRail_railInnerStyle--G79"};